import { Injectable } from '@angular/core';
import Recorder from 'opus-recorder';

const ENCODER_PATH = '/assets/encoderWorker.min.js';
const NUMBER_OF_CHANNELS = 1;
const ENCODER_SAMPLE_RATE = 16000;

// Sole entry point for the 'opus-recorder' lib in the app - callers only deal with generic
// start/stop, so swapping the recording implementation later only touches this file.
@Injectable({ providedIn: 'root' })
export class AudioRecorderService {
  private recorder: Recorder | null = null;

  public start(onDataAvailable: (chunk: ArrayBuffer) => void, onStop: () => void): Promise<void> {
    this.recorder = new Recorder({
      encoderPath: ENCODER_PATH,
      numberOfChannels: NUMBER_OF_CHANNELS,
      encoderSampleRate: ENCODER_SAMPLE_RATE,
    });
    this.recorder.ondataavailable = onDataAvailable;
    this.recorder.onstop = onStop;
    return this.recorder.start();
  }

  public stop(): void {
    this.recorder?.stop();
    this.recorder = null;
  }
}
